import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Injectable} from "@angular/core";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaSolicitante} from "../models/lista-solicitante";
import {NovaPessoa} from "../models/nova-pessoa";

@Injectable({
  providedIn: 'root'
})
export class PessoaService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`PessoaService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaSolicitante> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaSolicitante>>(`${this.baseUrl}/pessoa`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarListaAtivos(): Observable<BaseResponse<ListaSolicitante> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaSolicitante>>(`${this.baseUrl}/pessoa/ativos`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  adicionar(request: NovaPessoa): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/pessoa`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }
}
